class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.hasEnded = false;
    this.endDate = new Date().getTime();
    this.countdownId = this.id;
    this.hideExpiredDigits = this.dataset.hideExpiredDigits === "true";
    this.hideClockWhenExpired = this.dataset.countdownId.indexOf("active-") > -1 ? true : false;
    this.showLeadingZero = this.dataset.showLeadingZero === "true";
    this.hideOnceComplete = this.dataset.hideOnceComplete === "true";

    if (this.dataset.endDate) {
      // parse endDate, replacing dashes with slashes for Safari compatibility
      this.endDate = new Date(this.dataset.endDate.replace(/-/g, "/")).getTime();
    }

    this.weeksElement = this ? this.querySelector("weeks") : null;
    this.useWeeks = this.weeksElement;
    this.daysElement = this ? this.querySelector("days") : null;
    this.hoursElement = this ? this.querySelector("hours") : null;
    this.minutesElement = this ? this.querySelector("minutes") : null;
    this.secondsElement = this ? this.querySelector("seconds") : null;

    this.activeContentElement = this ? this.querySelector("active-content") : null;
    this.endContentElement = this ? this.querySelector("ended-content") : null;

    if (this.endDate) {
      this.setTimer();
    } else {
      console.warn("CountdownTimer Timer needs an end date");
    }
  }

  disconnectedCallback() {
    console.log("Custom element removed from page.");
  }

  showContent() {
    // add expired class to the closest section element
    if (this.hasEnded && this.hideOnceComplete) {
      let section = this.closest("section");
      if (section) {
        section.classList.add("expired");
      }
    }
  }

  setTimer() {
    const timer = () => {
      if (typeof this.endDate != "number") {
        return;
      }

      const now = new Date().getTime();
      let diff = this.endDate - now;

      if (diff <= 0) {
        // If countdown has ended, set all values to zero
        this.hasEnded = true;
        diff = 0;
      }

      this.showContent();

      let weeks = Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
      let days = Math.floor(diff / (1000 * 60 * 60 * 24)) % 7; // Remaining days if weeks are shown
      let totalDays = Math.floor(diff / (1000 * 60 * 60 * 24)); // Total days without weeks
      let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((diff % (1000 * 60)) / 1000);

      // If the countdown has ended, ensure all values show as 0 or 00
      if (this.hasEnded) {
        weeks = 0;
        days = 0;
        totalDays = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
      }

      if (this.useWeeks) {
        this.updateDigits(this.weeksElement, weeks);
        this.updateDigits(this.daysElement, days);
      } else {
        this.updateDigits(this.daysElement, totalDays);
      }

      this.updateDigits(this.hoursElement, hours);
      this.updateDigits(this.minutesElement, minutes);
      this.updateDigits(this.secondsElement, seconds);

      // Set display based on hideExpiredDigits setting
      this.setDisplay(this.weeksElement, weeks, weeks === 0);
      this.setDisplay(this.daysElement, this.useWeeks ? days : totalDays, weeks === 0 && totalDays === 0);
      this.setDisplay(this.hoursElement, hours, totalDays === 0 && hours === 0);
      this.setDisplay(this.minutesElement, minutes, totalDays === 0 && hours === 0 && minutes === 0);
      this.setDisplay(this.secondsElement, seconds, false); // Always show seconds even if it's 0

      if (this) {
        this.style.display = "flex";
        this.style.opacity = "1";
      }

      // Stop the timer if it has ended
      if (this.hasEnded) {
        clearInterval(intervalId);

        if (this.hideClockWhenExpired) {
          this.remove();
        }
      }
    };

    // Run the timer every second
    const intervalId = setInterval(timer, 1000);
    timer(); // Initial call to set the timer immediately
  }

  setDisplay(element, value, hideCondition = false) {
    if (!element) return;

    if (this.hideExpiredDigits && value === 0 && hideCondition) {
      // Hide the element if hideCondition is true and value is 0
      element.style.display = "none";
    } else {
      // Show the element if it should be visible
      element.style.display = "inline-flex";
    }
  }

  updateDigits(digitElement, value) {
    if (!digitElement) return;

    // Adding the zeros.
    const zeroPad = (num, places) => String(num).padStart(places, "0");

    let values = "";

    if (this.showLeadingZero) {
      values = zeroPad(value, 2).split("");
    } else {
      values = value.toString().split("");
    }

    let html = "";

    for (var i = 0; i < values.length; i++) {
      html += `<digit>${values[i]}</digit>`;
    }

    html = html === "" ? "<digit>0</digit><digit>0</digit>" : html;
    html = "<digits>" + html + "</digits>";

    let htmlDoc = new DOMParser().parseFromString(html, "text/xml");
    let htmlEl = htmlDoc.firstElementChild ? htmlDoc.firstElementChild : null;

    if (!htmlEl) return;

    if (!htmlEl.firstChild) return;

    if (digitElement.querySelector("digits")) {
      // replace current digits
      digitElement.querySelector("digits").innerHTML = htmlEl.innerHTML;
    } else {
      // append digits
      digitElement.appendChild(htmlEl);
    }
  }

  formatDigits(value) {
    // Adding the zeros.
    const zeroPad = (num, places) => String(num).padStart(places, "0");

    let values = value;

    if (this.showLeadingZero) {
      values = zeroPad(value, 2).split("");
    }

    let html = "";

    for (var i = 0; i < values.length; i++) {
      html += `<digit>${values[i]}</digit>`;
    }

    return html;
  }
}

customElements.define("ua-countdown-timer", CountdownTimer);
